import React from "react";
import PropTypes from "prop-types";
import SelectInput from "../../../common/forms/SelectInput";

const HoursTransactionTypeFilter = React.forwardRef((props, ref) => {
  return <SelectInput default="All" label="Type" onChange={props.onChange} options={props.types.sort()} ref={ref} />;
});

HoursTransactionTypeFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  types: PropTypes.array.isRequired,
};

export default HoursTransactionTypeFilter;
